import { render, staticRenderFns } from "./Panorama.vue?vue&type=template&id=3c5245bc&scoped=true"
import script from "./Panorama.vue?vue&type=script&lang=js"
export * from "./Panorama.vue?vue&type=script&lang=js"
import style0 from "./Panorama.vue?vue&type=style&index=0&id=3c5245bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5245bc",
  null
  
)

export default component.exports